import { ComponentProps, FC } from 'react';

import { SvgIcon } from './SvgIcon';

export const ChevronDown: FC<ComponentProps<typeof SvgIcon>> = props => (
  <SvgIcon width="16" height="16" viewBox="0 0 16 16" {...props}>
    <path d="M13.709 6.82383C14.0985 6.43225 14.0968 5.79909 13.7052 5.40962C13.3136 5.02014 12.6805 5.02185 12.291 5.41342L13.709 6.82383ZM8 11.1456L7.291 11.8508C7.47868 12.0395 7.73385 12.1456 8 12.1456C8.26615 12.1456 8.52132 12.0395 8.709 11.8508L8 11.1456ZM3.709 5.41342C3.31953 5.02185 2.68637 5.02014 2.2948 5.40962C1.90322 5.79909 1.90152 6.43225 2.291 6.82383L3.709 5.41342ZM12.291 5.41342L7.291 10.4404L8.709 11.8508L13.709 6.82383L12.291 5.41342ZM8.709 10.4404L3.709 5.41342L2.291 6.82383L7.291 11.8508L8.709 10.4404Z" />
  </SvgIcon>
);
